"use client";

import { useState, useEffect, type SetStateAction, type Dispatch } from "react";

export function useDelayedState<T>(
  initialValue: T,
  delay: number,
): [T, Dispatch<SetStateAction<T>>, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState<T>(initialValue);
  const [delayedState, setDelayedState] = useState<T>(initialValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDelayedState(state);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [state, delay]);

  const setImmidiateState = (newState: SetStateAction<T>) => {
    setState(newState);
    setDelayedState(newState);
  };

  return [delayedState, setState, setImmidiateState];
}
